import { render, staticRenderFns } from "./OrderSubmission.vue?vue&type=template&id=b2192ba8&scoped=true&"
import script from "./OrderSubmission.vue?vue&type=script&lang=js&"
export * from "./OrderSubmission.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmission.vue?vue&type=style&index=0&id=b2192ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2192ba8",
  null
  
)

export default component.exports